import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const ArticlesList = () => import(/* webpackChunkName: "articles" */ '@/views/Articles/List.vue');
const ArticleCreate = () => import(/* webpackChunkName: "articles" */ '@/views/Articles/Create.vue');
const ArticleEdit = () => import(/* webpackChunkName: "articles" */ '@/views/Articles/Edit.vue');

let articlesPages = {
  path: '/articles',
  redirect: '/articles',
  component: DashboardLayout,
  name: 'Articles',
  meta: {
    title: 'Artículos',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'ArticlesList',
      meta: {
        title: 'Listado',
        auth: ['articles.index'],
      },
      component: ArticlesList,
    },
    {
      path: 'create',
      name: 'ArticleCreate',
      meta: {
        title: 'Nuevo',
        auth: ['articles.store'],
      },
      component: ArticleCreate,
    },
    {
      path: ':id/edit',
      name: 'ArticleEdit',
      meta: {
        title: 'Editar',
        auth: ['articles.update'],
      },
      component: ArticleEdit,
    },
  ],
};

export default articlesPages;
